export const createEsiaRepository = (appFetch) => {
    return {
        referenceData(options = {}) {
            return appFetch.get('/cabinet/feedback/api/reference-data', options);
        },
    };
};
